var computeCacheStateForScripts = require('../utils/compute-cache-state')

module.exports = Em.View.extend({
    classNames: ['login-view', 'prelogin-view'],

    didInsertElement: function() {
        this._super()

        Em.run.scheduleOnce('afterRender', this, function() {
            var dataDog = window.DD_RUM
            var consume = window.__metrics__ && window.__metrics__.app_boot_consumed === false

            if (!consume) {
                return
            }

            if (window.__metrics__) {
                window.__metrics__.app_boot_consumed = true
            }

            var cacheState = computeCacheStateForScripts()
            var shellMs = performance.now()

            if (dataDog && typeof dataDog.addTiming === 'function') {
                dataDog.addTiming('login_shell_ready')
            }

            if (dataDog && typeof dataDog.addAction === 'function') {
                dataDog.addAction('login_load_metrics', {
                    phase: 'shell_ready',
                    entry_type: 'app_boot',
                    cache_state: cacheState,
                    shell_ms: Math.round(shellMs)
                })
            }
        })
    }
})
